module.exports = __webpack_public_path__ + "static/media/uoa-2.b306a1c8.jpg";